import { motion } from 'framer-motion';  
  
const Watermark = () => {  
  return (  
    <motion.div  
      className="absolute bottom-5 right-5 pointer-events-none z-10"  
    >  
      {/* Logo horizontal purple-negro como marca sutil */}  
      <img  
        src="https://codigoenblanco.com/assets/images/logos-nuevos/Logo-horizontal-Purple-Negro.svg"  
        alt="Código En Blanco"  
        className="w-40 h-auto"  
      />  
    </motion.div>  
  );  
};  
  
export default Watermark;